import React, { useEffect, useState } from "react";
import { Topbar } from "../../components/include/Topbar";
import { ErrorMessage, Field, Form, Formik } from "formik";
import { faqSchema } from "../../helpers/validations";
import { useLocation, useNavigate } from "react-router-dom";
import { Postdata } from "../../helpers/api.service";
import HttpService from "../../helpers/httpServices";
import { useDispatch, useSelector } from "react-redux";
import { message } from "../../redux/actions/toastActions";
import { isPermission, isRole } from "../../redux/selectors/authSelector";
import Error403Page from "../ErrorPage";

const Add_faqs = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [formInitialValues, setFormInitialValues] = useState({
    question: "",
    description: "",
  });
  const [isLoading, setIsloading] = useState(false);
  const selectedId = location.state?.id;
    const permissions = useSelector(isPermission);
  const role = useSelector(isRole)
  console.log("permissions", permissions)
  const isAccessible = role == "schooladmin" || permissions && permissions?.includes('edit_Admissions') || false;

  useEffect(() => {
    if (selectedId) {
      fetchData(selectedId);
    }
  }, [selectedId]);

  const fetchData = async (id) => {
    setIsloading(true);
    try {
      const response = await Postdata(HttpService.admission_faqs_show, { id });
      if (response.status === 200) {
        setFormInitialValues({
          question: response.data.question || "",
          description: response.data.description || "",
        });
      } else {
        dispatch(message(response.message));
      }
    } catch (error) {
      dispatch(message(error.message));
    } finally {
      setIsloading(false);
    }
  };

  const handleAddfaq = (
    values,
    setSubmitting,
    resetForm,
    setmodalswitch,
    setRefresh
    // dispatch
  ) => {
    const payload = {
      ...values,
      ...(selectedId ? { id: selectedId } : {}), // Only include `id` when editing
    };
    Postdata(HttpService.admission_faqs_add, payload)
      .then((response) => {
        if (response.status === 200) {
          dispatch(message("Guideline added successfully"));
          resetForm();
          navigate("/admissions/faqs");
          console.log("------------");
          //   setSelectedId(null);
        } else {
          dispatch(message(response.message));
        }
        setSubmitting(false);
      })
      .catch((error) => {
        dispatch(message(error.message));
        setSubmitting(false);
      });
  };

  if(!isAccessible){
    return <Error403Page/>
  }

  return (
    <>
      <Topbar title={`${location?.state?.mode === "Edit" ? "Edit" : "Add"} FAQ`} aerrow={true} />
      <div className="p-6 space-y-6 pr-0">
        <Formik
          initialValues={formInitialValues}
          enableReinitialize
          validationSchema={faqSchema}
          onSubmit={(values, { setSubmitting, resetForm }) =>
            handleAddfaq(
              values,
              setSubmitting,
              resetForm
              //   setRefresh,
              //   dispatch
            )
          }
        >
          {({ isSubmitting }) => (
            <Form className="w-full">
              <div>
                <label className="block mb-1 font-medium text-gray-700">
                  Question <span className="text-red-500">*</span>
                </label>
                <Field
                  type="text"
                  name="question"
                  placeholder="Enter Question"
                  className="input-field"
                />
                <ErrorMessage
                  name="question"
                  component="div"
                  className="text-red-500 "
                />
              </div>

              <div className="mt-2">
                <label className="block mb-1 font-medium text-gray-700">
                  Description <span className="text-red-500">*</span>
                </label>
                <Field
                  as="textarea"
                  name="description"
                  placeholder="Write here"
                  className="input-field"
                />
                <ErrorMessage
                  name="description"
                  component="div"
                  className="text-red-500"
                />
              </div>

              <div className="flex justify-center gap-3 mb-2 mt-4">
                <button
                  type="submit"
                  className="button-field-primary"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Submitting..." : "Submit"}
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </>
  );
};

export default Add_faqs;
